import StorageService from "./StorageService";
import LogHelper from "../helpers/LogHelper";
import ValidationHelper from "../helpers/ValidationHelper";

const EventSource = require("eventsource");

const SSEReconnectInterval = 1000;
const eventListener = new Map();
let isEventListenerInitialized = false;
let sse = null;

class TaskQueue {
  constructor() {
    this.arr = [];
    this.isWokring = false;
    this.process = this.process.bind(this);
    this.push = this.push.bind(this);
  }

  process() {
    if (this.isWokring) return;
    const latest = this.arr.shift();
    if (latest) {
      this.isWokring = true;
      latest();
      this.isWokring = false;
      this.process();
    }
  }

  push(task) {
    this.arr.push(task);
    this.process();
  }
}

const taskQueue = new TaskQueue();

class CamplaCoreService {
  static stripeUrlParameters() {
    const stripedUrl = (window.location.href + "").replace(/\?.*$/g, "");
    window.history.pushState({}, null, stripedUrl);
  }

  static getUrlParameter(name) {
    name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
    const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    // eslint-disable-next-line no-restricted-globals
    const results = regex.exec(location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  static addEventListener(id, listener) {
    eventListener.set(id, listener);
  }

  static removeEventListener(id) {
    eventListener.delete(id);
  }

  static authenticate(loginUrl = null) {
    StorageService.set("restoreQuery", window.location.href);
    if (loginUrl) {
      window.location.href = loginUrl;
    }else{
      window.location.href = `${window.RESTfulBaseURL}/auth/login`;
    }
  }

  static isiOS() {
    if (typeof window === `undefined` || typeof navigator === `undefined`)
      return false;
    return /iPhone|iPad|iPod/i.test(navigator.userAgent || navigator.vendor);
  }

  static async isAuthenticated() {
    const token = this.getToken();
    const authUser = this.getAuthenticatedUser();
    if (!ValidationHelper.isObject(authUser) || !ValidationHelper.isString(token)) {
      console.log("Invalid user credentials");
      return false;
    }

    try {
      const user = await CamplaCoreService.getMe();
      StorageService.setUser(user);
    } catch (error) {
      console.log("Couldn't fetch user");
      console.error(error);
    }

    return true;
  }

  static login(loginToken, loginIdentity, loginAppend) {
    const token = loginToken ? loginToken : CamplaCoreService.getUrlParameter("token");
    const append = loginAppend ? loginAppend === undefined : CamplaCoreService.getUrlParameter("append");
    if (token.length > 0) {
      if (token === "session") {
        try {
          CamplaCoreService.requestToken();
        } catch (err) {}
      } else {
        const identity = loginIdentity ? loginIdentity : JSON.parse(
          CamplaCoreService.getUrlParameter("identity")
        );
        StorageService.setToken(token);
        StorageService.setUser(identity);
        if (append && append.length > 0) {
          StorageService.remove("restoreQuery");
          window.location.href = append;
        } else {
          const restoreQuery = StorageService.getPrimitive("restoreQuery");
          if (restoreQuery) {
            StorageService.remove("restoreQuery");
            window.location.href = restoreQuery;
          } else {
            CamplaCoreService.stripeUrlParameters();
            console.log("Login successful");
          }
        }
      }
    }
  }

  static logout() {
    StorageService.setToken(null);
    StorageService.setUser(null);
    window.history.pushState({}, document.title, "/");
  }

  static getAuthenticatedUser() {
      return StorageService.getUser();
  }

  static getToken() {
    return StorageService.getToken();
  }

  static async internalLogin(data) {
    return await CamplaCoreService._requestJSONApi(
        "auth/internal",
        "POST",
        data,
        undefined,
        false
    );
  }

  static async requestToken() {
    return await CamplaCoreService._requestJSONApi(
      "auth/authenticator/token",
      "POST",
      {}
    );
  }

  static async createRapport(rapport) {
    return await CamplaCoreService._requestJSONApi("rapporte", "POST", rapport);
  }

  //-- ClassesController
  static async getAllClasses() {
    return await CamplaCoreService._requestJSONApi(
      "classes?extended=users",
      "GET"
    );
  }

  static async getClass(id) {
    return await CamplaCoreService._requestJSONApi(`classes/${id}`, "GET");
  }

  static async createClass(data) {
    return await CamplaCoreService._requestJSONApi("classes", "POST", data);
  }

  static async updateClass(id, data) {
    return await CamplaCoreService._requestJSONApi(
      `classes/${id}`,
      "PUT",
      data
    );
  }

  static async deleteClass(id) {
    return await CamplaCoreService._requestJSONApi(`classes/${id}`, "DELETE");
  }

  //--

  //-- GroupsController

  static async getAllGroups() {
    return await CamplaCoreService._requestJSONApi("groups", "GET");
  }

  static async deleteGroup(id) {
    return await CamplaCoreService._requestJSONApi(`groups/${id}`, "DELETE");
  }

  static async updateGroup(id, data) {
    return await CamplaCoreService._requestJSONApi(`groups/${id}`, "PUT", data);
  }

  static async createGroup(data) {
    return await CamplaCoreService._requestJSONApi("groups", "POST", data);
  }

  static async getUsergroups() {
    return await CamplaCoreService._requestJSONApi("usergroups", "GET");
  }

  static async deleteUsergroup(id) {
    return await CamplaCoreService._requestJSONApi(
      `usergroups/${id}`,
      "DELETE"
    );
  }

  static async createUsergroup(data) {
    return await CamplaCoreService._requestJSONApi("usergroups", "POST", data);
  }

  //--

  //-- ExaminationsController
  static async getAllExaminations() {
    return await CamplaCoreService._requestJSONApi(
      "examinations?extended=users",
      "GET"
    );
  }

  static async getStudentExaminations() {
    return await CamplaCoreService._requestJSONApi(
      "examinations/student",
      "GET"
    );
  }

  static async downloadSEB(os, fileName, progressListener) {
    return await CamplaCoreService._requestApiDownload(
      `examinations/student/seb?os=${os}`,
      fileName,
      progressListener
    );
  }

  static downloadSEBExternal(os) {
    const a = document.createElement("a");
    a.href =
      os === "macos"
        ? window.sebInstallers.macos
        : window.sebInstallers.windows;
    a.target = "_blank";
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  static async getExamination(id) {
    return await CamplaCoreService._requestJSONApi(`examinations/${id}`, "GET");
  }

  static async getExaminationInstances(id) {
    return await CamplaCoreService._requestJSONApi(
      `examinations/${id}/instances`,
      "GET"
    );
  }

  static async getExaminationInstancesWithStorage(id) {
    return await CamplaCoreService._requestJSONApi(
      `examinations/${id}/instances?extended=storage`,
      "GET"
    );
  }

  static async createExamination(data) {
    return await CamplaCoreService._requestJSONApi(
      "examinations",
      "POST",
      data
    );
  }

  static async cloneExamination(id, data) {
    return await CamplaCoreService._requestJSONApi(
      `examinations/${id}/clone`,
      "PUT",
      data
    );
  }

  static async updateExamination(id, data) {
    return await CamplaCoreService._requestJSONApi(
      `examinations/${id}`,
      "PUT",
      data
    );
  }

  static async deleteExamination(id) {
    return await CamplaCoreService._requestJSONApi(
      `examinations/${id}`,
      "DELETE"
    );
  }

  static async openExamination(id) {
    return await CamplaCoreService._requestNOJSONApi(
      `examinations/${id}/open`,
      "PUT"
    );
  }

  static async closeExamination(id) {
    return await CamplaCoreService._requestNOJSONApi(
      `examinations/${id}/close`,
      "PUT"
    );
  }

  static async pauseExamination(id) {
    return await CamplaCoreService._requestNOJSONApi(
      `examinations/${id}/pause`,
      "PUT"
    );
  }

  static async resumeExamination(id) {
    return await CamplaCoreService._requestNOJSONApi(
      `examinations/${id}/resume`,
      "PUT"
    );
  }

  static async RetryExaminationAction(id) {
    return await CamplaCoreService._requestNOJSONApi(
      `examinations/${id}/retry`,
      "PUT"
    );
  }

  static async getAllExaminationFiles(id) {
    return await CamplaCoreService._requestJSONApi(
      `examinations/${id}/files`,
      "GET"
    );
  }


  static async downloadOneExaminationFile(id, fid, fileName, progressListener) {
    return await CamplaCoreService._requestApiDownload(
        `examinations/${id}/files/${fid}`,
        fileName,
        progressListener
    );
  }

  static async uploadExaminationFile(id, data) {
    return await CamplaCoreService._requestApiUpload(
      `examinations/${id}/files`,
      data,
      "examFile"
    );
  }

  static async deleteExaminationFile(id, fileId) {
    return await CamplaCoreService._requestJSONApi(
      `examinations/${id}/files/${fileId}`,
      "DELETE"
    );
  }

  static async updateExaminationFile(id, fileId, data) {
    return await CamplaCoreService._requestJSONApi(
      `examinations/${id}/files/${fileId}`,
      "PUT",
      data
    );
  }

  static async downloadExaminationAttendanceList(id, format, fileName) {
    let os = 0;
    const patterns = ["Win", "Mac", "Linux", "X11"];
    for (const i in patterns) {
      if (navigator.appVersion.indexOf(patterns[i]) !== -1) {
        os = i + 1;
        break;
      }
    }
    return await CamplaCoreService._requestApiDownload(
      `examinations/${id}/attendancelist?format=${format}&os=${os}`,
      fileName
    );
  }

  static async downloadExaminationPinCodes(id, format, fileName, type = null) {
    let os = 0;
    const patterns = ["Win", "Mac", "Linux", "X11"];
    for (const i in patterns) {
      if (navigator.appVersion.indexOf(patterns[i]) !== -1) {
        os = i + 1;
        break;
      }
    }
    return await CamplaCoreService._requestApiDownload(
      type
        ? `examinations/${id}/pincodes?format=${format}&os=${os}&type=${type}`
        : `examinations/${id}/pincodes?format=${format}&os=${os}`,
      fileName
    );
  }

  static async downloadExaminationSubmissions(id, fileName, progressListener) {
    return await CamplaCoreService._requestApiDownload(
      `examinations/${id}/submissions`,
      fileName,
      progressListener
    );
  }

  static async getExaminationRestrictions(id) {
    return await CamplaCoreService._requestJSONApi(
      `examinations/${id}/restrictions`,
      "GET"
    );
  }

  static async updateExaminationRestrictions(id, data) {
    return await CamplaCoreService._requestJSONApi(
      `examinations/${id}/restrictions`,
      "PUT",
      data
    );
  }

  static async getDefaultRestrictions(id) {
    return await CamplaCoreService._requestJSONApi(
      `examinations/${id}/restrictions/default`,
      "GET"
    );
  }

  static async updateExaminationConfiguration(id, data) {
    return await CamplaCoreService._requestJSONApi(
      `examinations/${id}/configuration`,
      "PUT",
      data
    );
  }

  static async getExaminationSEBConfiguration(id, fileName) {
    return await CamplaCoreService._requestApiDownload(
      `examinations/${id}/configuration/seb`,
      fileName
    );
  }

  //--

  //-- InstancesController
  static async updateMemberDeviceHealth(data) {
    return await CamplaCoreService._requestJSONApi(
      "instances/memberdevice/health",
      "POST",
      data
    );
  }

  static async activateRAOfInstance(instanceId) {
    return await CamplaCoreService._requestJSONApi(
      `instances/remoteattestation/activate`,
      "POST",
      { instanceId }
    );
  }

  static async verifyRAOfInstance(instanceId, token) {
    return await CamplaCoreService._requestJSONApi(
      `instances/remoteattestation/verify`,
      "POST",
      { instanceId, token }
    );
  }

  static async resetRAOfInstance(instanceId) {
    return await CamplaCoreService._requestJSONApi(
      `instances/remoteattestation/reset`,
      "POST",
      { instanceId }
    );
  }

  static async startInstance(id) {
    return await CamplaCoreService._requestNOJSONApi(
      `instances/${id}/start`,
      "PUT"
    );
  }

  static async stopInstance(id) {
    return await CamplaCoreService._requestNOJSONApi(
      `instances/${id}/stop`,
      "PUT"
    );
  }

  static async downloadExaminationFile(
    id,
    pinCode,
    password,
    fileName,
    raToken,
    isSEBExamination = false,
    isLernstick = false
  ) {
    const parameter = [];
    if (pinCode.length > 0) parameter.push(`pincode=${pinCode}`);
    if (password.length > 0)
      parameter.push(`password=${encodeURIComponent(password)}`);
    if (raToken) parameter.push(`token=${raToken}`);
    if (isSEBExamination && isLernstick) parameter.push(`islernstick=true`);

    const resource = `instances/bridge/${id}/examfile${
      parameter.length > 0 ? "?" : ""
    }${parameter.join("&")}`;

    return isSEBExamination && !isLernstick
        ? await CamplaCoreService._requestApiDownloadByToken(
            id,
            resource,
            fileName
        )
        : await CamplaCoreService._requestApiDownload(resource, fileName);
  }

  static async downloadInstanceSubmission(id, fileName, progressListener) {
    return await CamplaCoreService._requestApiDownload(
      `instances/${id}/submission`,
      fileName,
      progressListener
    );
  }

  static async downloadInstanceBackup(id, fileName, progressListener) {
    return await CamplaCoreService._requestApiDownload(
      `instances/${id}/backup`,
      fileName,
      progressListener
    );
  }

  static async getExaminationFileDownloadOneTimeToken(id) {
    return await CamplaCoreService._requestJSONApi(
      `instances/${id}/examfile/onetimetoken`,
      "GET"
    );
  }

  static async resetExamFileDownload(id) {
    return await CamplaCoreService._requestNOJSONApi(
      `instances/${id}/examfile/reset`,
      "PUT"
    );
  }

  static async generateOneTimeToken(id) {
    return await CamplaCoreService._requestJSONApi(
      `instances/${id}/onetimetoken`,
      "GET"
    );
  }

  static async generateOneTimeStudentLogin(id) {
    return await CamplaCoreService._requestJSONApi(
        `instances/${id}/onetimestudentlogin`,
        "GET"
    );
  }

  static async quitSEBSession(id) {
    return await CamplaCoreService._requestNOJSONApi(
        `instances/${id}/seb/quit`,
        "PUT"
    );
  }

  //--

  //-- InstanceTemplatesController
  static async getAllInstanceTemplates() {
    return await CamplaCoreService._requestJSONApi("instancetemplates", "GET");
  }

  static async getInstanceTemplatesByTags(tags) {
    return await CamplaCoreService._requestJSONApi(
      `instancetemplates?filter=${JSON.stringify(tags)}`,
      "GET"
    );
  }

  static async getInstanceTemplateTags(tag) {
    return await CamplaCoreService._requestJSONApi(
      `instancetemplates/tags?tag=${tag}`,
      "GET"
    );
  }

  static async getInstanceTemplate(id) {
    return await CamplaCoreService._requestJSONApi(
      `instancetemplates/${id}`,
      "GET"
    );
  }

  static async getInstanceTemplateConfigurations() {
    return await CamplaCoreService._requestJSONApi(
      "instancetemplates/configurations",
      "GET"
    );
  }

  static async createInstanceTemplate(data) {
    return await CamplaCoreService._requestJSONApi(
      "instancetemplates",
      "POST",
      data
    );
  }

  static async updateInstanceTemplate(id, data) {
    return await CamplaCoreService._requestJSONApi(
      `instancetemplates/${id}`,
      "PUT",
      data
    );
  }

  static async deleteInstanceTemplate(id) {
    return await CamplaCoreService._requestNOJSONApi(
      `instancetemplates/${id}`,
      "DELETE"
    );
  }

  static async validateInstanceTemplate(data) {
    return await CamplaCoreService._requestJSONApi(
      "instancetemplates/validate",
      "POST",
      data
    );
  }

  //--

  //-- TemplateSoftwareController

  static async getAllTemplateSoftware() {
    return await CamplaCoreService._requestJSONApi("templatesoftware", "GET");
  }

  static async getTemplateSoftware(id) {
    return await CamplaCoreService._requestJSONApi(
      `templatesoftware/${id}`,
      "GET"
    );
  }

  static async createTemplateSoftware(data) {
    return await CamplaCoreService._requestJSONApi(
      "templatesoftware",
      "POST",
      data
    );
  }

  static async deleteTemplateSoftware(id) {
    return await CamplaCoreService._requestNOJSONApi(
      `templatesoftware/${id}`,
      "DELETE"
    );
  }
  //--

  //-- ModuleClassesController
  static async getAllModuleClasses() {
    return await CamplaCoreService._requestJSONApi(
      "moduleclasses?extended=users",
      "GET"
    );
  }

  static async getAllModuleClassesWithUsers() {
    return await CamplaCoreService._requestJSONApi(
      "moduleclasses?extended=users",
      "GET"
    );
  }

  static async getModuleClass(id) {
    return await CamplaCoreService._requestJSONApi(
      `moduleclasses/${id}`,
      "GET"
    );
  }

  static async getModuleClassExaminations(id) {
    return await CamplaCoreService._requestJSONApi(
      `moduleclasses/${id}/examinations`,
      "GET"
    );
  }

  static async createModuleClass(data) {
    return await CamplaCoreService._requestJSONApi(
      "moduleclasses",
      "POST",
      data
    );
  }

  static async updateModuleClass(id, data) {
    return await CamplaCoreService._requestJSONApi(
      `moduleclasses/${id}`,
      "PUT",
      data
    );
  }

  static async deleteModuleClass(id) {
    return await CamplaCoreService._requestJSONApi(
      `moduleclasses/${id}`,
      "DELETE"
    );
  }

  //--

  //-- ModulesController
  static async getAllModules() {
    return await CamplaCoreService._requestJSONApi("modules", "GET");
  }

  static async getModulesByAbbreviation(abbreviation) {
    return await CamplaCoreService._requestJSONApi(
      `modules?filter=${abbreviation}`,
      "GET"
    );
  }

  static async getModule(id) {
    return await CamplaCoreService._requestJSONApi(`modules/${id}`, "GET");
  }

  static async createModule(data) {
    return await CamplaCoreService._requestJSONApi("modules", "POST", data);
  }

  static async updateModule(id, data) {
    return await CamplaCoreService._requestJSONApi(
      `modules/${id}`,
      "PUT",
      data
    );
  }

  static async deleteModule(id) {
    return await CamplaCoreService._requestJSONApi(`modules/${id}`, "DELETE");
  }

  static async getAllModuleDepartments() {
    return await CamplaCoreService._requestJSONApi(
      `modules/departments`,
      "GET"
    );
  }

  //--

  //-- NetworkProfilesController
  static async getAllNetworkProfiles() {
    return await CamplaCoreService._requestJSONApi("networkprofiles", "GET");
  }

  static async getAllCloudNetworkProfiles() {
    return await CamplaCoreService._requestJSONApi(
      "networkprofiles/cloud",
      "GET"
    );
  }

  static async getNetworkProfile(id) {
    return await CamplaCoreService._requestJSONApi(
      `networkprofiles/${id}`,
      "GET"
    );
  }

  static async createNetworkProfile(data) {
    return await CamplaCoreService._requestJSONApi(
      "networkprofiles",
      "POST",
      data
    );
  }

  static async updateNetworkProfile(id, data) {
    return await CamplaCoreService._requestJSONApi(
      `networkprofiles/${id}`,
      "PUT",
      data
    );
  }

  static async deleteNetworkProfile(id) {
    return await CamplaCoreService._requestJSONApi(
      `networkprofiles/${id}`,
      "DELETE"
    );
  }

  //--

  //-- HardwareController
  static async getAllHardware() {
    return await CamplaCoreService._requestJSONApi("hardware", "GET");
  }

  static async getAllHardwareByTags(tags) {
    const rawTags = JSON.stringify(tags);
    return await CamplaCoreService._requestJSONApi(
      `hardware?filter=${rawTags}`,
      "GET"
    );
  }

  static async lookupHardwareByTags(tags) {
    const rawTags = JSON.stringify(tags);
    return await CamplaCoreService._requestJSONApi(
      `hardware/lookup?tags=${rawTags}`,
      "GET"
    );
  }

  static async getHardware(id) {
    return await CamplaCoreService._requestJSONApi(`hardware/${id}`, "GET");
  }

  static async createHardware(data) {
    return await CamplaCoreService._requestJSONApi("hardware", "POST", data);
  }

  static async updateHardware(id, data) {
    return await CamplaCoreService._requestJSONApi(
      `hardware/${id}`,
      "PUT",
      data
    );
  }

  static async deleteHardware(id) {
    return await CamplaCoreService._requestJSONApi(`hardware/${id}`, "DELETE");
  }

  //--

  //-- ScriptsController
  static async getAllScripts() {
    return await CamplaCoreService._requestJSONApi("scripts", "GET");
  }

  static async getScript(id) {
    return await CamplaCoreService._requestJSONApi(`scripts/${id}`, "GET");
  }

  static async createScript(data) {
    return await CamplaCoreService._requestJSONApi("scripts", "POST", data);
  }

  static async updateScript(id, data) {
    return await CamplaCoreService._requestJSONApi(
      `scripts/${id}`,
      "PUT",
      data
    );
  }

  static async deleteScript(id) {
    return await CamplaCoreService._requestJSONApi(`scripts/${id}`, "DELETE");
  }

  static async validateScript(data) {
    return await CamplaCoreService._requestJSONApi(
      "scripts/validate",
      "POST",
      data
    );
  }

  //--

  //-- StatisticsController
  static async getAllStatistics() {
    return await CamplaCoreService._requestJSONApi("statistics", "GET");
  }

  static async getAllAuditLogs() {
    return await CamplaCoreService._requestJSONApi(
      "statistics/audit/logs",
      "GET"
    );
  }

  //--

  //-- UsersController
  static async getMe() {
    return await CamplaCoreService._requestJSONApi("users/me", "GET");
  }

  static async getUser(id) {
    return await CamplaCoreService._requestJSONApi(`users/${id}`, "GET");
  }

  static async getAllUsers() {
    return await CamplaCoreService._requestJSONApi("users", "GET");
  }

  static async lookupUser(startsWith) {
    return await CamplaCoreService._requestJSONApi(
      `users/lookup?startswith=${startsWith}`
    );
  }

  static async createUser(data) {
    return await CamplaCoreService._requestJSONApi("users", "POST", data);
  }

  static async updateUser(id, data) {
    return await CamplaCoreService._requestJSONApi(`users/${id}`, "PUT", data);
  }

  static async deleteUser(id) {
    return await CamplaCoreService._requestJSONApi(`users/${id}`, "DELETE");
  }

  //--

  //-- TemplateScriptsController
  static async getAllTemplateScripts() {
    return await CamplaCoreService._requestJSONApi("templatescripts", "GET");
  }

  static async getTemplateScript(id) {
    return await CamplaCoreService._requestJSONApi(
      `templatescripts/${id}`,
      "GET"
    );
  }

  static async createTemplateScript(data) {
    return await CamplaCoreService._requestJSONApi(
      "templatescripts",
      "POST",
      data
    );
  }

  static async deleteTemplateScript(id) {
    return await CamplaCoreService._requestJSONApi(
      `templatescripts/${id}`,
      "DELETE"
    );
  }

  //--

  //-- StudentFileController
  static async getAllStudentFilesByExamination(eid) {
    return await CamplaCoreService._requestJSONApi(
      `studentfile/examination/${eid}`,
      "GET"
    );
  }

  static async getAllStudentFilesByStudentExamination(eid) {
    return await CamplaCoreService._requestJSONApi(
      `studentfile/examination/${eid}/student`,
      "GET"
    );
  }

  static async acceptStudentFile(id) {
    return await CamplaCoreService._requestNOJSONApi(
      `studentfile/${id}/accept`,
      "PUT"
    );
  }

  static async rejectStudentFile(id) {
    return await CamplaCoreService._requestNOJSONApi(
      `studentfile/${id}/reject`,
      "PUT"
    );
  }

  static async deleteStudentFile(id) {
    return await CamplaCoreService._requestJSONApi(
      `studentfile/${id}`,
      "DELETE"
    );
  }

  static async downloadStudentFile(id, fileName, progressListener) {
    return await CamplaCoreService._requestApiDownload(
      `studentfile/${id}`,
        fileName,
        progressListener
    );
  }

  static async uploadStudentFile(eid, data) {
    return await CamplaCoreService._requestApiUpload(
      `studentfile/examination/${eid}`,
      data,
      "studentFile"
    );
  }

  static async getAllStudentExamFilesByInstance(iid) {
    return await CamplaCoreService._requestJSONApi(
      `studentfile/instance/${iid}/files`,
      "GET"
    );
  }

  static async downloadStudentExamFile(iid, fid, fileName) {
    return await CamplaCoreService._requestApiDownload(
      `studentfile/instance/${iid}/files/${fid}`,
      fileName
    );
  }

  static async uploadStudentExamFile(iid, data) {
    return await CamplaCoreService._requestApiUpload(
      `studentfile/instance/${iid}/files`,
      data,
      "studentFile"
    );
  }

  static async deleteStudentExamFile(iid, fid) {
    return await CamplaCoreService._requestJSONApi(
      `studentfile/instance/${iid}/files/${fid}`,
      "DELETE"
    );
  }

  //--

  //-- PaperNotesController
  static async getAllPaperNotes(eid) {
    return await CamplaCoreService._requestJSONApi(`papernotes/${eid}`, "GET");
  }

  static async uploadPaperNotes(eid, data) {
    return await CamplaCoreService._requestApiUpload(
      `papernotes/${eid}`,
      data,
      "notesFile",
      false
    );
  }

  static async downloadAllPaperNotes(eid, fileName) {
    return await CamplaCoreService._requestApiDownload(
      `papernotes/${eid}/instance`,
      fileName
    );
  }

  static async downloadPaperNotes(eid, iid, fileName) {
    return await CamplaCoreService._requestApiDownload(
      `papernotes/${eid}/instance/${iid}`,
      fileName
    );
  }

  static async deletePaperNotes(id) {
    return await CamplaCoreService._requestJSONApi(
      `papernotes/${id}`,
      "DELETE"
    );
  }

  //--

  //-- IsolationHardwareController
  static async getAllIsolationHardware() {
    return await CamplaCoreService._requestJSONApi(`isolationhardware`, "GET");
  }

  static async getIsolationHardware(id) {
    return await CamplaCoreService._requestJSONApi(
      `isolationhardware/${id}`,
      "GET"
    );
  }

  static async getIsolationHardwareByIdentifier(id) {
    return await CamplaCoreService._requestJSONApi(
      `isolationhardware/identifier/${id}`,
      "GET"
    );
  }

  static async getIsolationHardwareBySerialNumber(id) {
    return await CamplaCoreService._requestJSONApi(
      `isolationhardware/serialnumber/${id}`,
      "GET"
    );
  }

  static async createIsolationHardware(data) {
    return await CamplaCoreService._requestJSONApi(
      `isolationhardware`,
      "POST",
      data
    );
  }

  static async updateIsolationHardware(id, data) {
    return await CamplaCoreService._requestJSONApi(
      `isolationhardware/${id}`,
      "PUT",
      data
    );
  }

  static async deleteIsolationHardware(id) {
    return await CamplaCoreService._requestJSONApi(
      `isolationhardware/${id}`,
      "DELETE"
    );
  }
  //--

  //-- SentinelController
  static async setDevicePolicy(data) {
    return await CamplaCoreService._requestJSONApi(
      "sentinel/devices/policy",
      "POST",
      data
    );
  }

  static async getDevicePolicy() {
    return await CamplaCoreService._requestJSONApi(
      "sentinel/devices/policy",
      "GET"
    );
  }

  static async activateDevicePolicy() {
    return await CamplaCoreService._requestJSONApi(
      "sentinel/devices/policy/activate",
      "PUT"
    );
  }

  static async deactivateDevicePolicy() {
    return await CamplaCoreService._requestJSONApi(
      "sentinel/devices/policy/deactivate",
      "PUT"
    );
  }

  static async getDeviceLogs() {
    return await CamplaCoreService._requestJSONApi(
      "sentinel/devices/logs",
      "GET"
    );
  }

  static async stageMemberDevice(data) {
    return await CamplaCoreService._requestJSONApi(
      "sentinel/devices/stage",
      "POST",
      data
    );
  }

  static async registerMemberDevice(data) {
    return await CamplaCoreService._requestJSONApi(
      "sentinel/devices/register",
      "POST",
      data
    );
  }

  static async getAllMemberDevicesOfClass(id) {
    return await CamplaCoreService._requestJSONApi(
      `sentinel/class/${id}`,
      "GET"
    );
  }

  static async getAllReplacementDevices() {
    return await CamplaCoreService._requestJSONApi(
      `sentinel/replacement`,
      "GET"
    );
  }

  static async assignReplacementDevice(data) {
    return await CamplaCoreService._requestJSONApi(
      `sentinel/replacement/instance`,
      "POST",
      data
    );
  }

  static async freeReplacementDevice(id) {
    return await CamplaCoreService._requestJSONApi(
      `sentinel/replacement/instance/${id}`,
      "DELETE"
    );
  }

  static async createReplacementDevice(data) {
    return await CamplaCoreService._requestJSONApi(
      `sentinel/replacement`,
      "POST",
      data
    );
  }

  static async resetReplacementDevice(id) {
    return await CamplaCoreService._requestJSONApi(
      `sentinel/replacement/${id}/reset`,
      "PUT"
    );
  }

  static async removeMemberDevice(id) {
    return await CamplaCoreService._requestJSONApi(
      `sentinel/devices/${id}`,
      "DELETE"
    );
  }

  static async getSentinelStatus() {
    return await CamplaCoreService._requestJSONApi(`sentinel/status`, "GET");
  }
  //--

  //-- SoftwareCatalogsController
  static async getAllSoftwareCatalogs() {
    return await CamplaCoreService._requestJSONApi("softwarecatalogs", "GET");
  }

  static async getSoftwareCatalog(id) {
    return await CamplaCoreService._requestJSONApi(
      `softwarecatalogs/${id}`,
      "GET"
    );
  }

  static async createSoftwareCatalog(data) {
    return await CamplaCoreService._requestJSONApi(
      "softwarecatalogs",
      "POST",
      data
    );
  }

  static async updateSoftwareCatalog(id, data) {
    return await CamplaCoreService._requestJSONApi(
      `softwarecatalogs/${id}`,
      "PUT",
      data
    );
  }

  static async deleteSoftwareCatalog(id) {
    return await CamplaCoreService._requestJSONApi(
      `softwarecatalogs/${id}`,
      "DELETE"
    );
  }

  static async uploadSoftwareCatalogPackage(id, file) {
    return await CamplaCoreService._requestApiUpload(
      `softwarecatalogs/${id}/packages`,
      file,
      "software"
    );
  }

  static async updateSoftwareCatalogPackage(catalogId, packageId, file) {
    const formData = new FormData();
    formData.append("software", file);
    return await CamplaCoreService._requestApi(
      `softwarecatalogs/${catalogId}/packages/${packageId}`,
      {
        type: "PUT",
        data: formData,
        params: null,
        mimeType: "none",
        responseType: "json",
        authorized: true,
      }
    );
  }

  static async deleteSoftwareCatalogPackage(catalogId, packageId) {
    return await CamplaCoreService._requestJSONApi(
      `softwarecatalogs/${catalogId}/packages/${packageId}`,
      "DELETE"
    );
  }

  //--

  // Extended fetch methods
  static async getExtendedExaminations() {
    const covertToMap = (arr) => {
      const map = new Map();
      arr.forEach((i) => map.set(i._id, i));
      return map;
    };

    const classesMap = covertToMap(await CamplaCoreService.getAllClasses());
    const modulesMap = covertToMap(await CamplaCoreService.getAllModules());
    const moduleClasses = await CamplaCoreService.getAllModuleClasses();
    const examinations = await CamplaCoreService.getAllExaminations();
    const instanceTemplates = await CamplaCoreService.getAllInstanceTemplates();
    const networkProfiles = await CamplaCoreService.getAllNetworkProfiles();

    const instanceTemplateMap = covertToMap(instanceTemplates);

    const moduleClassesMap = new Map();
    const examinationsIndexMap = new Map();
    const extendedModuleClasses = moduleClasses
      .filter((mc) => classesMap.has(mc.classId) && modulesMap.has(mc.moduleId))
      .map((mc) => {
        const newMc = Object.assign(mc, {
          className: classesMap.get(mc.classId).name,
          moduleName: modulesMap.get(mc.moduleId).name,
        });
        moduleClassesMap.set(newMc._id, newMc);
        return newMc;
      });

    const extendedExaminations = examinations
        .filter(ex => moduleClassesMap.has(ex.moduleClassId) && instanceTemplateMap.has(ex.instanceTemplateId))
        .map((ex, idx) => {
          const mc = moduleClassesMap.get(ex.moduleClassId);
          const newEx = Object.assign(ex, {
            instanceTemplate: instanceTemplateMap.get(ex.instanceTemplateId),
            className: mc.className,
            moduleName: mc.moduleName,
      });
      examinationsIndexMap.set(ex._id, idx);
      return newEx;
    });

    StorageService.set("extendedExaminations", extendedExaminations);
    StorageService.set("extendedModuleClasses", extendedModuleClasses);
    StorageService.set("moduleClassesMap", moduleClassesMap, "map");
    StorageService.set("instanceTemplates", instanceTemplates);
    StorageService.set("networkProfiles", networkProfiles);
    StorageService.set("examinationsIndexMap", examinationsIndexMap, "map");

    return {
      classesCount: classesMap.size,
      moduleClasses: extendedModuleClasses,
      examinations: extendedExaminations,
      examinationsIndexMap: examinationsIndexMap,
      moduleClassesMap: moduleClassesMap,
      instanceTemplates: instanceTemplates,
      networkProfiles: networkProfiles,
    };
  }

  static resetEventSource() {
    if (sse) {
      LogHelper.log("Event Source", "Close event source");
      sse.close();
    }
  }

  static addWorkerQueueTask(task) {
    taskQueue.push(task);
  }

  //--

  static async _requestApiDownloadByToken(id, resource, fileName) {
    const {
      token,
    } = await CamplaCoreService.getExaminationFileDownloadOneTimeToken(id);
    let url =
      resource.indexOf("?") === -1
        ? `${window.RESTfulBaseURL}/${resource}?onetimetoken=${token}`
        : `${window.RESTfulBaseURL}/${resource}&onetimetoken=${token}`;
    if (fileName === "exam.seb") {
      url = url.replace("https://", "sebs://");
      url = url.replace("http://", "seb://");
    }
    const a = document.createElement("a");
    a.href = url;
    //a.download = fileName;
    document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
    a.click();
    a.remove(); //afterwards we remove the element again
  }

  static async _requestApiDownload(
    resource,
    fileName,
    progressListener = null
  ) {
    const token = StorageService.getToken();
    const options = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await fetch(
      `${window.RESTfulBaseURL}/${resource}`,
      options
    );

    if (response.headers.has("content-type")
        && response.headers.get("content-type").indexOf("application/json") !== -1) {
      const handle = await response.json();
      if (handle && typeof handle["redirectUrl"] !== "undefined"){
        window.open(handle.redirectUrl, '_blank');
      }
      return;
    }

    if (response.ok) {
      let blob;
      if (progressListener) {
        const reader = response.body.getReader();
        const contentLength = response.headers.get("Content-Length");
        let receivedLength = 0; // received that many bytes at the moment
        let chunks = []; // array of received binary chunks (comprises the body)
        let percentage = 0;
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          chunks.push(value);
          receivedLength += value.length;
          if (contentLength >= 0) {
            const newPercentage = Math.round(
              (receivedLength / contentLength) * 100
            );
            if (newPercentage !== percentage)
              progressListener(percentage, receivedLength);
            percentage = newPercentage;
          } else {
            progressListener(-1, receivedLength);
          }
        }
        blob = new Blob(chunks);
      } else {
        blob = await response.blob();
      }
      if (progressListener || blob.size > 0) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove(); //afterwards we remove the element again
      }
      return;
    }

    // eslint-disable-next-line
    throw {
      status: response.status,
      statusText: response.statusText,
    };
  }

  static async _requestApiUpload(resource, file, fieldName, hasAnswer = true) {
    const formData = new FormData();
    formData.append(fieldName, file);
    return await CamplaCoreService._requestApi(resource, {
      type: "POST",
      data: formData,
      params: null,
      mimeType: "none",
      responseType: hasAnswer ? "json" : null,
      authorized: true,
    });
  }

  static async _requestJSONApi(resource, type, data, params, authorized) {
    return await CamplaCoreService._requestApi(resource, {
      type: type,
      data: typeof data === "undefined" ? null : data,
      params: typeof params === "undefined" ? null : params,
      mimeType: "json",
      responseType: "json",
      authorized: typeof authorized === "undefined" ? true : authorized,
    });
  }

  static async _requestNOJSONApi(resource, type, data, params, authorized) {
    return await CamplaCoreService._requestApi(resource, {
      type: type,
      data: typeof data === "undefined" ? null : data,
      params: typeof params === "undefined" ? null : params,
      mimeType: null,
      responseType: null,
      authorized: typeof authorized === "undefined" ? true : authorized,
    });
  }

  static _setupEventSource() {
    isEventListenerInitialized = true;
    LogHelper.log("Event Source", "Start initializing");
    const id = Date.now();
    const token = StorageService.getToken();
    sse = new EventSource(`${window.RESTfulBaseURL}/events/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    sse.onopen = () => {
      LogHelper.log("Event Source", `Connected client with id ${id}`);
    };
    sse.onmessage = (event) => {
      try {
        LogHelper.log("Event Source", event.data);
        const parsedData = JSON.parse(event.data);
        try {
          eventListener.forEach((l) => l(parsedData));
        } catch (err) {
          LogHelper.log("Event Source", `Error in listener: ${err}`);
        }
      } catch (err) {
        LogHelper.log("Event Source", "Invalid event format: No json event.");
      }
    };
    sse.onerror = (err) => {
      LogHelper.log("Event Source", `Connection error: ${JSON.stringify(err)}`);
      sse.close();
      LogHelper.log("Event Source", `Disconnected client with id ${id}`);
      setTimeout(CamplaCoreService._setupEventSource, SSEReconnectInterval);
    };
  }

  static async _requestApi(resource, config) {
    const { type, data, mimeType, responseType, authorized } = config;
    const options = { method: type, headers: {} };

    if (authorized) {
      const token = StorageService.getToken();
      options.headers["Authorization"] = `Bearer ${token}`;
    }
    if (data !== null) {
      options["body"] = mimeType === "json" ? JSON.stringify(data) : data;
      if (mimeType !== "none") {
        options.headers["Content-Type"] =
          mimeType === "json" ? "application/json" : mimeType;
      }
    }
    const response = await fetch(
      `${window.RESTfulBaseURL}/${resource}`,
      options
    );
    LogHelper.log(
      "Request Api",
      `${window.RESTfulBaseURL}/${resource}: ${response.status}`
    );
    if (response.ok) {
      if (!isEventListenerInitialized && authorized) {
        CamplaCoreService._setupEventSource();
      }
      return responseType === "json" && type !== "DELETE"
        ? await response.json()
        : response;
    }

    // eslint-disable-next-line
    throw {
      status: response.status,
      statusText: response.statusText,
    };
  }
}

export default CamplaCoreService;
